import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    input,
    signal,
    ViewChild,
} from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'telxl-truncate-text',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgbTooltip],
    templateUrl: './truncate-text.component.html',
    styleUrl: './truncate-text.component.scss',
})
export class TelXLTruncateTextComponent implements AfterViewInit {
    text = input<string>();
    useToolTip = input<boolean>(false);

    @ViewChild('textElement', { static: true })
    textElement!: ElementRef<HTMLElement>;

    isTruncated = signal(false);

    ngAfterViewInit() {
        const el = this.textElement.nativeElement;
        this.isTruncated.set(
            el.scrollWidth > el.clientWidth && this.useToolTip(),
        );
    }
}
